import { useLocation } from 'react-router';
import { useMemo } from 'react';

export function useQueryParams(): URLSearchParams {
  const location = useLocation();
  return useMemo(() => new URLSearchParams(location.search), [location.search]);
}
